exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-posts-2023-building-mdx": () => import("./../../../src/pages/posts/2023/building.mdx" /* webpackChunkName: "component---src-pages-posts-2023-building-mdx" */),
  "component---src-pages-vinterlytics-tsx": () => import("./../../../src/pages/vinterlytics.tsx" /* webpackChunkName: "component---src-pages-vinterlytics-tsx" */),
  "component---src-templates-hn-issue-tsx": () => import("./../../../src/templates/HNIssue.tsx" /* webpackChunkName: "component---src-templates-hn-issue-tsx" */)
}

